import styled from "styled-components";

import SearchForm, { SearchField } from "../../../components/design/layout/search";

export const Form = styled(SearchForm)`
    flex-direction: row;
    padding-right: 0;
    padding-left: 15px;

    input[type=text],
    input[type=search],
    button[type=submit] {
        height: 38px
    }
`;

export const Field = styled(SearchField)`
    height: 38px !important;
`;

export const WrapperContent = styled.div`
    position: fixed;
    top: 58px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: ${({theme}) => theme.zIndex.contentFixed};
    overflow: scroll;
    overscroll-behavior: contain;
    padding-bottom: 6.625rem;
    background-color: ${({theme}) => theme.color.white};
`;